export default "__VITE_ASSET__NIo_2yp1__"